import ClientError from 'clients/errors/ClientError';
import ServerError from 'clients/errors/ServerError';
import { getToken } from 'http/clientToken';
import utils from 'helpers/utils';

export default (function () {
    function openFile(blob, filename, type) {
        // Creating a new blob object with mime-type explicitly set
        const newBlob = new Blob([
            blob,
        ], { type: type || 'application/pdf' });

        /*
         * IE doesn't allow using a blob object directly as link href
         * instead it is necessary to use msSaveOrOpenBlob
         */
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);

            return;
        }

        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        let link = document.createElement('a');

        link.href = data;
        link.download = filename;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL
        setTimeout(() => {
            return window.URL.revokeObjectURL(data);
        }, 100);
    }

    /**
     * Create an XHR request to fetch a file from the MOBIAN API.
     *
     * @param {string} url
     * @param {Object} config - [config={}].
     * @returns {Promise}
     */
    function request(url, config) {
        config = config || {};

        const requestConfig = {
            method: config.method || 'GET',
            credentials: 'include',
            headers: {},
        };

        const clientToken = getToken();

        if (clientToken) {
            requestConfig.headers['Client-Application-Token'] = clientToken;
        }

        if (config.params) {
            url = utils.buildUrl(url, config.params);
        }

        return fetch(url, requestConfig).then(function (response) {
            const statusCode = Math.floor(response.status / 100);

            // Client error
            if (statusCode === 4) {
                return response.json().then(function (response) {
                    throw new ClientError('client-error', response.status, response);
                });
            }

            // Server error
            if (statusCode === 5) {
                return response.json().then(function (response) {
                    throw new ServerError('server-error', response.status, response);
                });
            }

            return response.blob();
        }, function (error) {
            throw new Error(error);
        }).then((blob) => {
            return openFile(blob, config.filename, config.type);
        });
    }

    return {
        getPDF: function (url, filename, params) {
            return request(url, {
                method: 'GET',
                filename,
                params,
                type: 'application/pdf',
            });
        },
    };
})();



// WEBPACK FOOTER //
// ./src/clients/fileClient.js